// extracted by mini-css-extract-plugin
export default {"container":"RelativeDatesEditor_container__DywcZ","editor":"RelativeDatesEditor_editor__BGChs"};